import Spline from "@splinetool/react-spline";
import Face from "./images/facetime.jpg";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Experience, Projects, SocialLinks } from "./data";
import { IoLogoGithub, IoMenu } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Typed from "typed.js";

function App() {
  const [isActive, setIsActive] = useState(false);
  const element = useRef("");

  useEffect(() => {
    const typingEffect = new Typed(element.current, {
      strings: ["", "Narayan", "Developer", "Coder", "Engineer"],
      loop: true,
      startDelay: 300,
      typeSpeed: 100,
      backSpeed: 80,
      backDelay: 1500,
      smartBackspace: true,
      showCursor: true,
    });
  }, []);

  // const goTo = () => {
  //   return (
  //     <a href="https://drive.google.com/file/d/1D4-Hgf8J3rQhqsmSUpCQ4ATX8CMRW3KF/view?usp=sharing"></a>
  //   );
  // };
  // useEffect(() => {
  //   goTo();
  // }, []);

  return (
    <AnimatePresence initial={false}>
      <div className="flex w-screen min-h-screen flex-col items-center justify-center relative bg-primary pb-20">
        <nav className="w-full px-6 z-50  fixed inset-x-0 top-2 flex justify-center items-center ">
          <div className=" w-full md:w-880 bg-navBar p-4 rounded-2xl flex items-center">
            <p className="text-lg text-slate-200 font-medium">Narayan</p>

            <div className="hidden md:flex items-center gap-6 ml-6 flex-1">
              <a
                href="#home"
                className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Home
              </a>
              <a
                href="#about"
                className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                About
              </a>
              <a
                href="#projects"
                className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Projects
              </a>
              <a
                href="#contacts"
                className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Contact
              </a>
              <a
                href="https://drive.google.com/file/d/1D4-Hgf8J3rQhqsmSUpCQ4ATX8CMRW3KF/view?usp=sharing"
                className="ml-auto text-base text-slate-200 font-medium hover:text-slate-100 cursor-pointer border border-textSmoke px-2 py-1 rounded-xl hover:border-gray-100 duration-100 ease-in"
              >
                Download
              </a>
            </div>

            <motion.div
              whileTap={{ scale: 0.6 }}
              className="block md:hidden  ml-auto cursor-pointer"
              onClick={() => setIsActive(!isActive)}
            >
              <IoMenu className="text-2xl text-textBase " />
            </motion.div>
            {isActive && (
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1.1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ delay: "0.1s", type: "spring" }}
                className="p-4 w-275 bg-navBar rounded-lg fixed top-24 right-16 flex flex-col items-center justify-evenly gap-6"
              >
                <a
                  href="#home"
                  className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Home
                </a>
                <a
                  href="#about"
                  className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  About
                </a>
                <a
                  href="#projects"
                  className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Projects
                </a>
                <a
                  href="#contacts"
                  className="text-base text-textSmoke font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Contact
                </a>
                <a
                  href="https://drive.google.com/file/d/1D4-Hgf8J3rQhqsmSUpCQ4ATX8CMRW3KF/view?usp=sharing"
                  className="text-base text-slate-200 font-medium hover:text-slate-100 cursor-pointer border border-textBase px-2 py-1 rounded-xl hover:border-gray-100 duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Download
                </a>
              </motion.div>
            )}
          </div>
        </nav>

        <div className="relative" id="home">
          {/* <Spline scene="https://prod.spline.design/oo6IxFu8UDjFUmjD/scene.spline" /> */}
          <Spline scene="https://prod.spline.design/UGYQVa9UuYiAXE7v/scene.splinecode" />
          <div className="absolute bottom-10 w-full flex justify-center items-center">
            <div className="shadow-md p-4 flex flex-col items-center justify-center bg-zinc-900 rounded-3xl ">
              <p className="text-white">drag orbit in 3D</p>
            </div>
          </div>
        </div>

        <main className="w-[80%] mt-4">
          <section
            className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 my-24"
            id="about"
          >
            <div className="w-full h-420 flex items-center justify-center">
              <div className="w-275 h-340 relative bg-zinc-900 rounded-md hover:bg-zinc-800">
                <img
                  src={Face}
                  alt=""
                  className="w-full h-full absolute -right-4 top-4 object-cover rounded-lg drop-shadow-2xl"
                />
              </div>
            </div>
            <div className="w-full h-420 flex flex-col items-center justify-center ">
              <div className="w-full h-auto flex flex-col items-start justify-start ml-12">
                <span className="text-2xl font-bold text-textBase relative tracking-widest p-2">
                  {" "}
                  Hello
                  <span className="w-12 h-1 absolute content-none bottom-3 bg-gradient-to-br from-green-400 to-blue-600 mx-2 mt-1">
                    {" "}
                  </span>
                </span>
                <h1 className="text-5xl text-textBase font-black tracking-wider">
                  {" "}
                  I'm{" "}
                  <span ref={element} className="text-blue-500">
                    {" "}
                  </span>
                </h1>
              </div>
              <p className="text-lg text-textSmoke text-center mt-4">
                I am constantly on the move, always eager to learn more and
                educate myself. I hope to gain more knowledge by working highly
                competitive environment, with experienced people and be a better
                me.
              </p>
              <button
                className="w-full md:w-auto relative mt-6 inline-flex items-center 
              justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 
              rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 
              group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:ring-green-200 
              dark:focus:ring-green-800 hover:shadow-lg hover:shadow-teal-500/50 hover:dark:shadow-lg 
              hover:dark:shadow-teal-800/80"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    "https://drive.google.com/file/d/1D4-Hgf8J3rQhqsmSUpCQ4ATX8CMRW3KF/view?usp=sharing";
                }}
              >
                <span
                  className="w-full md:w-auto relative px-5 py-2.5 transition-all ease-in duration-75 
                bg-amber-100 dark:bg-gray-900 rounded-md group-hover:bg-opacity-0"
                >
                  Download
                </span>
              </button>
            </div>
          </section>

          <section className="w-full flex items-center justify-center">
            <VerticalTimeline>
              {Experience &&
                Experience.map((n) => (
                  <VerticalTimelineElement
                    key={n.id}
                    className="vertical-timeline-element--work"
                    contentStyle={{
                      background: "rgb(21, 24, 31)",
                      color: "#888",
                    }}
                    contentArrowStyle={{
                      borderRight: "7px solid  rgb(21, 24, 31)",
                    }}
                    date={n.date}
                    iconStyle={{ background: "rgb(21, 24, 31)", color: "#888" }}
                    icon={n.iconsSrc}
                  >
                    <h3 className="text-textSmoke vertical-timeline-element-title">
                      {n.title}
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle">
                      {n.location}
                    </h4>
                    <p>{n.description}</p>
                  </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
          </section>
          <section
            className="flex flex-wrap items-center justify-evenly my-24 gap-4"
            id="projects"
          >
            {Projects &&
              Projects.map((n, i) => (
                <motion.div
                  key={n.id}
                  className="border border-zinc-800 rounded-md p-2 min-w-[275px] md:max-w-[275px] 
                  hover:border-zinc-600 duration-100 ease-in-out"
                >
                  <p className="text-lg text-textBase font-medium uppercase">
                    {n.name.length > 25 ? `${n.name.slice(0, 25)}...` : n.name}
                  </p>
                  <a href={n.link}>
                    <img
                      src={n.imageSrc}
                      className="w-full h-full object-cover rounded-md my-4"
                      alt="Screen-shot"
                    />
                  </a>
                  <div className="flex flex-1 items-center justify-between">
                    <p className="text-lg text-gray-300">
                      Technologies
                      <span className="block text-sm text-gray-500">
                        {n.techs}
                      </span>
                    </p>
                    <a href={n.github}>
                      <motion.div whileTap={{ scale: 0.5 }}>
                        <IoLogoGithub className="text-textBase text-3xl cursor-pointer" />
                      </motion.div>
                    </a>
                  </div>
                </motion.div>
              ))}
          </section>

          <section
            id="contacts"
            className="flex flex-col items-center justify-evenly w-full mt-32"
          >
            <p className="text-2xl text-gray-400">Reach out here</p>
            <div className="flex items-center justify-evenly w-full my-12 flex-wrap gap-4">
              {SocialLinks &&
                SocialLinks.map((n) => (
                  <motion.a
                    whileTap={{ scale: 0.8 }}
                    href={n.link}
                    key={n.id}
                    className="w-full md:w-auto px-3 md:px-8 py-5 border border-zinc-800 rounded-2xl hover:border-zinc-600 duration-100 ease-in-out cursor-pointer flex items-center justify-center gap-3"
                  >
                    {n.iconSrc}
                    <p className="text-lg text-textBase">{n.name}</p>
                  </motion.a>
                ))}
            </div>
          </section>
        </main>
      </div>
    </AnimatePresence>
  );
}

export default App;